export { default } from './SideContent';
export { SideContentProps } from './SideContent.types';
